import React, { ReactElement, Dispatch, SetStateAction } from 'react';

import Modal from '~/components/Modal';
import Code from '~/components/flow/Code';
import COLORS from '~/constants/colors';

interface DisplayProps {
  message: string;
  setMessage: Dispatch<SetStateAction<string>>;
}

function Display({ message, setMessage }: DisplayProps): ReactElement {
  const hider = () => setMessage('');

  // Rendering
  const title = 'Who was the leaker?';

  // Styling
  const revealStyle = {
    lineHeight: '1.75em',
  };
  const closeStyle = {
    position: 'absolute' as const,
    top: '0.9em',
    right: '0.9em',
    width: '1.5em',
    height: '1.5em',
    textAlign: 'center' as const,
    cursor: 'pointer',
  };
  const fSlashStyle = {
    display: 'inline-block',
    height: '1.5em',
    width: '0.3em',
    backgroundColor: COLORS.silver,
    transform: 'rotate(45deg)',
  };
  const bSlashStyle = {
    ...fSlashStyle,
    transform: 'rotate(90deg)',
  };

  return (
    <Modal visible={!!message} title={title} hider={hider}>
      <div
        role="button"
        tabIndex={0}
        onMouseUp={hider}
        onTouchEnd={hider}
        style={closeStyle}
      >
        <div style={fSlashStyle}>
          <div style={bSlashStyle} />
        </div>
      </div>
      <div>
        The identifying message encoded into the image was:
        <ul>
          <li style={revealStyle}>
            <Code>{message}</Code>
          </li>
        </ul>
      </div>
    </Modal>
  );
}

export default Display;
